// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewport {
  position: relative;
  padding: 10px;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  display: flex;
  flex-direction: column;
}
.viewport .video-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.viewport .video-container.video-container-in-sharing {
  width: 264px;
  flex-shrink: 0;
}
.viewport .video-container.single-video-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.viewport .video-container .single-video-wrap {
  width: 100%;
  aspect-ratio: 16/9;
  height: auto;
  position: relative;
  max-height: 100%;
}
.viewport .video-container .video-canvas {
  width: 100%;
  height: 100%;
}
.viewport .video-container .self-video {
  position: absolute;
  width: 254px;
  height: 143px;
  top: 50px;
  right: 30px;
  z-index: 2;
  display: none;
}
.viewport .video-container .self-video.single-self-video {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.viewport .video-container .self-video.self-video-show {
  display: block;
}
.viewport .video-container .ant-radio-button-wrapper {
  z-index: 1;
}
.viewport .video-container .video-container-wrap {
  height: 100%;
  overflow: hidden;
}
.viewport .video-container .user-list {
  height: calc(100% - 65px);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(33.33% - 10px), 1fr));
  grid-auto-rows: minmax(calc(33.33% - 10px), 1fr);
  grid-gap: 10px;
  padding-inline: 30px;
}
.viewport .video-container .user-list .video-cell.single-frame {
  grid-column: 1/-1;
  grid-row: 1/-1;
}
.viewport .video-container .user-list .video-cell {
  position: relative;
}
.viewport .video-container .user-list .video-cell .change-video-resolution {
  position: absolute;
}
.viewport .video-container .user-list .video-cell .video-player {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.viewport .avatar-list {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  padding: 0;
  margin: 0;
}
.viewport .avatar-wrap {
  position: absolute;
  pointer-events: auto;
  list-style: none;
  top: 0;
  left: 0;
}
.viewport .avatar-wrap-dragging {
  z-index: 10;
}
.viewport .single-view-avatar {
  top: 0;
  left: 0;
}
.viewport .self-video-tag {
  display: none;
  position: absolute;
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}

.pagination-controls .page-info {
  margin: 0 7px;
  font-size: 16px;
  font-weight: bold;
}

.pagination-controls button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid white;
  background-color: transparent;
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
}

.pagination-controls button:disabled:hover {
  background: transparent;
  border: 1px solid dodgerblue;
  color: dodgerblue;
}

.pagination-controls button:disabled {
  color: #ffffff;
  border: 1px solid white;
  background-color: transparent;
  cursor: not-allowed;
}

.pagination-controls button:hover {
  border: 1px solid dodgerblue;
  color: dodgerblue;
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/feature/video/video.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AACF;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAEJ;AAGI;EACE,YAAA;EACA,cAAA;AADN;AAGI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AADN;AAGI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AADN;AAII;EACE,WAAA;EACA,YAAA;AAFN;AAII;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;AAFN;AAGM;EACE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AADR;AAGM;EACE,cAAA;AADR;AAII;EACE,UAAA;AAFN;AAII;EACE,YAAA;EACA,gBAAA;AAFN;AAII;EACE,yBAAA;EACA,aAAA;EACA,yEAAA;EACA,gDAAA;EACA,cAAA;EACA,oBAAA;AAFN;AAGM;EACE,iBAAA;EACA,cAAA;AADR;AAGM;EACE,kBAAA;AADR;AAEQ;EACE,kBAAA;AAAV;AAEQ;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAAV;AAKE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAHJ;AAUE;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,MAAA;EACA,OAAA;AARJ;AAUE;EACE,WAAA;AARJ;AAUE;EACE,MAAA;EACA,OAAA;AARJ;AAUE;EACE,aAAA;EACA,kBAAA;AARJ;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AARF;;AAWA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;AARF;;AAWA;EACE,uBAAA;EACA,4BAAA;EACA,iBAAA;AARF;;AAWA;EACE,cAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;AARF;;AAWA;EACE,4BAAA;EACA,iBAAA;EACA,6BAAA;AARF","sourcesContent":[".viewport {\n  position: relative;\n  padding: 10px;\n  box-sizing: border-box;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n  display: flex;\n  flex-direction: column;\n  .video-container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    // &.video-container-attech {\n    //   display: flex;\n    //   align-items: center;\n    // }\n    &.video-container-in-sharing {\n      width: 264px;\n      flex-shrink: 0;\n    }\n    &.single-video-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    .single-video-wrap {\n      width: 100%;\n      aspect-ratio: 16/9;\n      height: auto;\n      position: relative;\n      max-height: 100%;\n    }\n\n    .video-canvas {\n      width: 100%;\n      height: 100%;\n    }\n    .self-video {\n      position: absolute;\n      width: 254px;\n      height: 143px;\n      top: 50px;\n      right: 30px;\n      z-index: 2;\n      display: none;\n      &.single-self-video {\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n      }\n      &.self-video-show {\n        display: block;\n      }\n    }\n    .ant-radio-button-wrapper {\n      z-index: 1;\n    }\n    .video-container-wrap {\n      height: 100%;\n      overflow: hidden;\n    }\n    .user-list {\n      height: calc(100% - 65px);\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(calc(33.33% - 10px), 1fr));\n      grid-auto-rows: minmax(calc(33.33% - 10px), 1fr);\n      grid-gap: 10px;\n      padding-inline: 30px;\n      .video-cell.single-frame {\n        grid-column: 1/-1;\n        grid-row: 1/-1;\n      }\n      .video-cell {\n        position: relative;\n        .change-video-resolution {\n          position: absolute;\n        }\n        .video-player {\n          display: block;\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n        }\n      }\n    }\n  }\n  .avatar-list {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n  }\n  // .video-operations {\n  //   position: absolute;\n  //   left: 0;\n  //   bottom: 0;\n  // }\n  .avatar-wrap {\n    position: absolute;\n    pointer-events: auto;\n    list-style: none;\n    top: 0;\n    left: 0;\n  }\n  .avatar-wrap-dragging {\n    z-index: 10;\n  }\n  .single-view-avatar {\n    top: 0;\n    left: 0;\n  }\n  .self-video-tag {\n    display: none;\n    position: absolute;\n  }\n}\n.pagination-controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 15px;\n}\n\n.pagination-controls .page-info {\n  margin: 0 7px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.pagination-controls button {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid white;\n  background-color: transparent;\n  color: white;\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.3s;\n}\n\n.pagination-controls button:disabled:hover {\n  background: transparent;\n  border: 1px solid dodgerblue;\n  color: dodgerblue;\n}\n\n.pagination-controls button:disabled {\n  color: #ffffff;\n  border: 1px solid white;\n  background-color: transparent;\n  cursor: not-allowed;\n}\n\n.pagination-controls button:hover {\n  border: 1px solid dodgerblue;\n  color: dodgerblue;\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
